import { ApiOnboardingPath } from "./utils/config";
import getAllQueryParams from "./utils/getAllQueryParams";

const ApiHost = process.env.REACT_APP_API_BASE_URL;
const ApiToken = process.env.REACT_APP_JWT_TOKEN;
const RegisterUserURL = `${ApiHost}/users`;

const onboardingId = document.body.getAttribute("data-journey-id");

export default function apiConnector() {
  const stepTouchURL = `${ApiHost}/${ApiOnboardingPath}/${onboardingId}/user`;
  const getInitialJourneyURL = `${ApiHost}/${ApiOnboardingPath}/`;

  let userId;

  async function stepTouch(step) {
    let bodyData;

    if (
      typeof step.value === "object" &&
      step.value !== null &&
      !Array.isArray(step.value)
    ) {
      /*
       * In the FormStep the values come as { value: { [dataId]: dataValue ... }}
       */
      bodyData = step.value;
    } else {
      /*
       * In most steps the values come as { id: dataId, value: dataValue }
       */
      bodyData = {
        [step.id]: step.value,
      };
    }

    if (!userId) {
      userId = await registerUser();
    }

    bodyData.userId = userId;
    bodyData.stepId = step.id;
    const response = await fetch(stepTouchURL, {
      method: "PATCH",
      headers: {
        Authorization: ApiToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(bodyData),
    });
    const parsed = await response.json();
    if (parsed && parsed.code === "RESOURCE_CREATED") {
      userId = parsed.body && parsed.body.user && parsed.body.user.id;
    }

    return parsed;
  }

  async function getInitialJourney() {
    const response = await fetch(getInitialJourneyURL + onboardingId, {
      headers: {
        Authorization: ApiToken,
      },
    });

    return response.json();
  }

  return {
    stepTouch,
    getInitialJourney,
  };
}

async function registerUser() {
  const queryParams = getAllQueryParams(window.location.href);
  const response = await fetch(RegisterUserURL, {
    method: "POST",
    headers: {
      Authorization: ApiToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ onboardingId: onboardingId, queryParams }),
  });

  const { body } = await response.json();

  return body.user.id;
}
